import fetch from 'isomorphic-fetch';

const ENDPOINT_URL = process.env.VUE_APP_JIRA_CREATE_ISSUE_URL;
async function crearIssueSoporte(detalle, ruc, issueID) {
  const bodyParams = {
    detalle,
    ruc,
    issueID,
    token: localStorage.getItem('token'),
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { crearIssueSoporte };
